import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { LocationInputContainer } from 'components/LocationInput/LocationInputContainer';
import { deepExtract } from 'helpers/deep';

export class LocationInputField extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.handleLoad = this.handleLoad.bind(this);
  }

  handleChange(location) {
    const { input } = this.props;
    input.onChange(location);

    // "Touch" the field to trigger validation.
    input.onFocus();
    input.onBlur();
  }

  handleLoad(location) {
    const { input } = this.props;
    input.onChange(location);
  }

  render() {
    const { input, inputAttributes, label, meta, suppressErrorMessage, wrapperAttributes, wrapperTag } = this.props;

    const hasError = meta.error && meta.touched;

    const inputElement = (
      <LocationInputContainer
        initialValue={deepExtract('location.name', input.value)}
        inputAttributes={{
          ...inputAttributes,
          className: classNames(inputAttributes.className, {
            'form__input--error': hasError,
          }),
        }}
        label={label}
        onChange={this.handleChange}
        onLoad={this.handleLoad}
      />
    );

    let errorElement;
    if (hasError) {
      errorElement = typeof meta.error === 'string' ? meta.error : <FormattedMessage {...meta.error} />;
    }

    return React.createElement(
      wrapperTag || 'div',
      wrapperAttributes || {},
      inputElement,
      hasError && !suppressErrorMessage ? <div className="error__text text--sm mt-">{errorElement}</div> : null
    );
  }
}

LocationInputField.propTypes = {
  input: PropTypes.shape({
    onBlur: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    onFocus: PropTypes.func.isRequired,
    value: PropTypes.object,
  }),
  inputAttributes: PropTypes.object,
  meta: PropTypes.object,
  label: PropTypes.element,
  suppressErrorMessage: PropTypes.bool,
  wrapperAttributes: PropTypes.object,
  wrapperTag: PropTypes.string,
};
